module.exports = __webpack_public_path__ + "static/img/document-pdf.122fd1e0.svg";